export class ScheduleNewBranchDays {
  constructor(
    public ID?: number,
    public DayOfWeek?: number,
    public OpeningHour?: string,
    public ClosingHour?: string,
    public OpeningHourDelivery?: string,
    public ClosingHourDelivery?: string,
    public BranchID?: number
  ) { }
}
